<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
    <el-dialog
      :visible.sync="exitSoftware"
      :close-on-press-escape="false"
      title="退出应用"
      width="300px"
    >
      <span slot="footer" class="dialog-footer">
        <el-button @click="exitSoftware = false">取 消</el-button>
        <el-button type="primary" @click="ensureFn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import store from '@/store'
import { mapMutations } from 'vuex'
import { platform } from '@/api/config'

// const token1 =
//   'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vZGVhcGkuY3psa3MuY29tIiwiYXVkIjoiaHR0cDovL2RlYXBpLmN6bGtzLmNvbS92MS9sb2dpbiIsImp0aSI6InR6a2oiLCJpYXQiOjE2OTU3MjU3ODIuNDQwMDEyLCJleHAiOjE2OTU3MjkzODIuNDQwMDEyLCJ1aWQiOiIxNjk1NzI1NzY0MDAwNDcyIn0.9ETNV2QJxfG9ve7XVjtgvwj-UDqTSDKuxFEUAy6c0XQ'
// if (token1) {
//   store.dispatch('getUserInfo')
//   store.commit('SET_TOKEN', token1)
//   sessionStorage.setItem('token', token1)
// }


const token = sessionStorage.getItem('token')
if (token) {
  store.commit('SET_TOKEN', token)
  store.dispatch('getUserInfo')
}

export default {
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true,
      socket: null, // WebSocket对象
      timer: null,
      exitSoftware: false // 退出软件弹窗
    }
  },
  created() {
    this.changeIco()
    this.socketInitFn()
    const _this = this
    document.onkeydown = function (e) {
      if (e.keyCode === 27) _this.exitSoftware = true
    }
  },
  methods: {
    ...mapMutations({
      setRouterPath: 'SET_ROUTER_PATH'
    }),
    socketInitFn() {
      clearInterval(this.timer)
      const d = this.getQueryString('d')
      if (d) {
        this.socket = new WebSocket('ws:deliver.czlks.cn:9502')
        this.socket.onopen = this.socketOpen
        this.socket.onerror = this.socketError
        this.socket.onmessage = this.socketMessage
        this.timer = setInterval(() => {
          this.onSocketSend(d)
        }, 10000)
      }
    },
    socketOpen() {},
    socketError() {},
    socketMessage() {},
    onSocketSend(d) {
      this.socket.send(d)
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
    // 修改Favicon的方法
    changeFavicon(link) {
      let $favicon = document.querySelector('link[rel="icon"]')
      if ($favicon !== null) {
        $favicon.href = link
      } else {
        $favicon = document.createElement("link")
        $favicon.rel = 'icon'
        $favicon.href = link
        document.head.appendChild($favicon)
      }
    },
    // 根据传递的参数修改Favicon
    changeIco() {
      let iconUrl
      if (platform === 'msyz') {
        iconUrl = `./msyz_favicon.ico`
      } else if (platform === 'szzy') {
        iconUrl = `./szzy_favicon.ico`
      }
      this.changeFavicon(iconUrl)
    },
    getQueryString(name) {
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      const search = window.location.hash.split('?')[1]
      if (search) {
        const r = search.match(reg)
        if (r != null) {
          return unescape(r[2])
        } else {
          return null
        }
      } else {
        return null
      }
    },
    // 当用户点击确定退出
    ensureFn() {
      history.go(-history.length + 1)
    }
  },
  watch: {
    $route(to) {
      this.setRouterPath(to.path)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="stylus" scoped></style>
